import { keyframes } from 'styled-components';
export const realTimeFadeIn = keyframes(["0%{opacity:0;transform:translateY(-10px);}100%{opacity:1;transform:translateY(0);}"]);
export const realTimeFadeOut = keyframes(["0%{opacity:1;transform:translateY(0);}100%{opacity:0;transform:translateY(-10px);}"]);